function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from "styled-components";
import { Badge } from "reactstrap";
import { LeftVerticalCentered } from "../styled/VerticalCentered";
import { connect } from "react-redux";
const StyledTextSpan = styled.span`
  padding-right: .5rem;
`;
const StyledBadgeWrapper = styled.div`
  position: relative;
  display: inline-block;
  height: .9rem;
  width: 2rem;
`;

class BadgedText extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getBadgeColor", () => {
      if (this.props.darkModeSwitch) {
        return this.props.darkMode ? `${this.props.color}-lighten` : this.props.color;
      }

      return this.props.color;
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTextSpan, null, this.props.children), /*#__PURE__*/React.createElement(StyledBadgeWrapper, {
        style: this.props.badgeStyle
      }, /*#__PURE__*/React.createElement(LeftVerticalCentered, null, /*#__PURE__*/React.createElement(Badge, {
        color: this.getBadgeColor(),
        cypress: this.props.cypress
      }, this.props.badge))));
    });
  }

}

function mapStateToProps(state) {
  return {
    darkMode: state.layout.darkMode
  };
}

export default connect(mapStateToProps, {})(BadgedText);